import { useEffect } from 'react';

function ForceReloadOnBack() {
  useEffect(() => {
    const handlePageShow = (event) => {
      if (event.persisted) {
        // Page is restored from bfcache — force reload
        window.location.reload();
      }
    };
    window.addEventListener('pageshow', handlePageShow);
    return () => window.removeEventListener('pageshow', handlePageShow);
  }, []);

}
export default ForceReloadOnBack;